export async function openAuthenticatedPayslip(
  downloadPath: string,
): Promise<void> {
  const previewTab = window.open('about:blank', '_blank');
  try {
    const baseUrl = (window as typeof window & {appGlobal: {baseUrl: string}})
      .appGlobal.baseUrl;
    const url = `${baseUrl}${downloadPath}${
      downloadPath.includes('?') ? '&' : '?'
    }raw=1`;
    const response = await fetch(url, {
      credentials: 'same-origin',
    });
    const contentType = response.headers.get('content-type') || '';
    if (!response.ok || contentType.includes('text/html')) {
      previewTab?.close();
      throw new Error('Payslip could not be opened');
    }
    const blobUrl = URL.createObjectURL(await response.blob());
    if (previewTab) {
      previewTab.location.replace(blobUrl);
    } else {
      window.open(blobUrl, '_blank');
    }
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  } catch (error) {
    previewTab?.close();
    throw error;
  }
}
